// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__23TP1","large":"styles_large__J-I9Q"};